var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReactMarkdown from 'react-markdown';
import { Code } from './Code';
import { Heading } from './Heading';
import { Link } from './Link';
import { List } from './List';
import { ListItem } from './ListItem';
import { Paragraph } from './Paragraph';
import { Typography } from '@criteria-labs/react';
function textContent(node) {
    return node.children.map((child) => (child.type === 'text' ? child.value : '')).join('');
}
export function Markdown({ content }) {
    if (!content) {
        return null;
    }
    return (_jsx(Typography, { className: "text-xs", children: _jsx(ReactMarkdown, { components: {
                a: (props) => {
                    const { children, node } = props, rest = __rest(props, ["children", "node"]);
                    return _jsx(Link, Object.assign({}, rest, { children: children }));
                },
                code: (props) => {
                    const { children, node } = props, rest = __rest(props, ["children", "node"]);
                    const isFenced = (node === null || node === void 0 ? void 0 : node.position) && node.position.end.line > node.position.start.line;
                    const raw = node ? textContent(node) : '';
                    return (_jsx(Code, Object.assign({ content: raw, inline: !isFenced }, rest, { children: children })));
                },
                p: (props) => {
                    const { children, node } = props, rest = __rest(props, ["children", "node"]);
                    return _jsx(Paragraph, Object.assign({}, rest, { children: children }));
                },
                ul: (props) => {
                    const { children, node } = props, rest = __rest(props, ["children", "node"]);
                    return _jsx(List, Object.assign({}, rest, { children: children }));
                },
                li: (props) => {
                    const { children, node } = props, rest = __rest(props, ["children", "node"]);
                    return _jsx(ListItem, Object.assign({}, rest, { children: children }));
                },
                h1: (props) => {
                    const { children, node } = props, rest = __rest(props, ["children", "node"]);
                    return (_jsx(Heading, Object.assign({ level: 1 }, rest, { children: children })));
                },
                h2: (props) => {
                    const { children } = props, rest = __rest(props, ["children"]);
                    return (_jsx(Heading, Object.assign({ level: 2 }, rest, { children: children })));
                },
                h3: (props) => {
                    const { children } = props, rest = __rest(props, ["children"]);
                    return (_jsx(Heading, Object.assign({ level: 3 }, rest, { children: children })));
                },
                h4: (props) => {
                    const { children } = props, rest = __rest(props, ["children"]);
                    return (_jsx(Heading, Object.assign({ level: 4 }, rest, { children: children })));
                }
            }, children: content }) }));
}
